import clsx from 'clsx';
import logoSvg from '@/assets/images/svg/logo.svg';
import logoCollapsedSvg from '@/assets/images/svg/logo_collapsed_icon.svg';
import type { HeaderConfig } from './types';

/**
 * Derives the visual configuration for the header based on collapsed state.
 * Uses the existing PNG logo asset to avoid missing SVG dependencies.
 */
export const getHeaderConfig = (isCollapsed: boolean): HeaderConfig => ({
  containerPadding: isCollapsed ? 'px-1 pt-6 pb-4' : 'pt-6 pb-6',

  // Use the specific SVG logos for expanded/collapsed
  logoSrc: isCollapsed ? logoCollapsedSvg : logoSvg,

  logoClass: clsx(
    'object-contain',
    isCollapsed ? 'size-auto max-h-[40px] max-w-[60px]' : 'h-[49px] w-[89px]'
  ),

  avatarSize: isCollapsed ? 65 : 90,

  avatarClass: clsx(
    'bg-gray-340 border-3 border-brand-300',
    'transition-all duration-300',
    isCollapsed ? 'mb-2' : 'mb-3'
  ),
});
